<template>
<div>
  <div class="mb-6" style="display:grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
    <div class="main-card" :class="selectMenu === 1 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(1)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 1" src="@/assets/images/menu/menu-safety-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-safety.svg" alt="safety">
        <p>안전</p>
      </div>
    </div>
    <div class="main-card" :class="selectMenu === 2 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(2)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 2" src="@/assets/images/menu/menu-state-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-state.svg" alt="safety">
        <p>환경</p>
      </div>
    </div>
    <div class="main-card" :class="selectMenu === 3 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(3)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 3" src="@/assets/images/menu/menu-health-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-health.svg" alt="safety">
        <p>보건</p>
      </div>
    </div>
    <div class="main-card" :class="selectMenu === 4 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(4)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 4" src="@/assets/images/menu/menu-approval-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-approval.svg" alt="safety">
        <p>결재함</p>
      </div>
    </div>
    <div class="main-card" :class="selectMenu === 5 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(5)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 5" src="@/assets/images/menu/menu-daily-check-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-daily-check.svg" alt="safety">
        <p>일일점검</p>
      </div>
    </div>
    <div class="main-card" :class="selectMenu === 6 ? 'active' : ''" style="max-height: 100px;" @click="clickMenu(6)">
      <div class="main-card-icon" >
        <img v-if="selectMenu === 6" src="@/assets/images/menu/menu-prevention-active.svg" alt="safety">
        <img v-else src="@/assets/images/menu/menu-prevention.svg" alt="safety">
        <p>시정 및 예방</p>
      </div>
    </div>
  </div>

  <div v-if="selectMenu === 1" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/regular-assessment', true)">정기위험성평가</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/regular-assessment-always', true)">수시위험성평가</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/daily-checklist', true)">일일안전점검표</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/daily-checklist-always', true)">수시일일안전점검표</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/daily-checklog', true)">안전점검일지</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/daily-checklog-always', true)">수시안전점검일지</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/equipment-checklist', true)">장비점검계획</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/equipment-checkresult', true)">장비점검 결과</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/daily-checklogall', true)">합동점검일지</vs-button>
  </div>
  <div v-else-if="selectMenu === 2" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/state/daily-checklist', true)">환경일일점검</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/state/monthly-checklist', true)">환경월간점검</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/state/monitoring-checklist', true)">환경점검모니터링</vs-button>
  </div>
  <div v-else-if="selectMenu === 3" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/content/community/healthinfo', true)">안전보건 주요일정</vs-button>
  </div>
  <div v-else-if="selectMenu === 4" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/request', true)">결재요청함</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/await', true)">결재대기함</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/process', true)">결재진행함</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/complete', true)">완료문서함</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/reject', true)">반려문서함</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/approval/reference', true)">참조/회람 문서함</vs-button>
  </div>
  <div v-else-if="selectMenu === 5" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/safety/equipment-checklist', true)">일일안전점검</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/state/daily-checklist', true)">일일환경점검</vs-button>
  </div>
  <div v-else-if="selectMenu === 6" class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/prevention/safety-request', true)">안전이슈</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/prevention/environment-request', true)">환경이슈</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/prevention/health-request', true)">보건이슈</vs-button>
  </div>
  <div v-else class="sub-menu">
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/content/community/businessnews', true)">CEO 메세지</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/content/community/qna', true)">Q&A</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/content/community/healthinfo', true)">안전보건 주요일정</vs-button>
    <vs-button class="p-0" color="secondary" type="border" @click="movePage('/content/community/unitbusinessnews', true)">구성원 요청사항</vs-button>
  </div>

  <div class="main-card" style="height:auto; margin-bottom: 1.5rem;">
    <div class="w-full" style="padding:1.5rem;">
      <div class="font-bold mb-5"><i class="dot"></i>투입인원현황</div>
      <div class="w-full text-center">금일 투입인원 : {{ sumOfEmployees | comma }}명</div>
      <e-charts autoresize :options="numOfEmployees" theme="ovilia-green" style="height:180px;"
                auto-resize/>
    </div>
  </div>
  <div class="main-card" style="height:auto; margin-bottom: 1.5rem;">
    <div class="w-full" style="padding:1.5rem;">

      <div class="font-bold mb-5"><i class="dot"></i>투입장비현황</div>
      <div class="w-full text-center">금일 투입장비 : {{ sumOfEquipment | comma }}명</div>
      <e-charts autoresize :options="numOfEquipment" theme="ovilia-green" style="height:180px;"
                auto-resize/>
    </div>

  </div>
  <div class="main-card" style="height:auto; margin-bottom: 1.5rem;">
    <div class="w-full" style="padding:1.5rem;">

      <div class="font-bold"><i class="dot"></i>일일 안전점검 현황 : {{ sumOfSafetyCheckStatus }}회</div>

      <e-charts autoresize :options="numOfSafetyCheckStatus" theme="ovilia-green" style="height:200px;"
                auto-resize/>
    </div>
  </div>

</div>
</template>

<script>

import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'

export default {
  name: 'Index',
  components: {
    ECharts
  },
  data () {
    return {
      selectMenu: 0,

      sumOfEmployees: 0,
      numOfEmployees: {
        legend: {
          left: 'center',
          bottom: 'bottom'
        },
        tooltip: {},
        dataset: {
          // Provide data.
          source: [
            ['성별', '남성', '여성', '고령'],
            ['사무소명1', '500', '600', '700'],
            ['사무소명2', '300', '400', '500'],
            ['사무소명3', '300', '400', '500']
          ]
        },
        grid: {
          top: '15%',
          left: '15%',
          right: '3%'
        },
        xAxis: {type: 'category'},
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#BFC9D1',
            formatter (value) {
              return `${value}명`
            }
          },
          axisLine: {
            show: true
          }
        },
        series: [
          {
            type: 'bar',
            color: '#7367F0'
          },
          {
            type: 'bar',
            color: '#EA5455'
          },
          {
            type: 'bar',
            color: '#28C76F'
          }
        ]
      },

      sumOfEquipment: 0,
      numOfEquipment: {
        legend: {
          left: 'center',
          bottom: 'bottom'
        },
        tooltip: {},
        dataset: {
          // Provide data.
          source: [
            ['성별', '일반', '노후', '고위험'],
            ['사무소명1', '20', '1', '2'],
            ['사무소명2', '10', '3', '3'],
            ['사무소명3', '5', '0', '1']
          ]
        },
        grid: {
          top: '15%',
          left: '15%',
          right: '3%'
        },
        xAxis: {type: 'category'},
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#BFC9D1',
            formatter (value) {
              return `${value}개`
            }
          },
          axisLine: {
            show: true
          }
        },
        series: [
          {
            type: 'bar',
            color: '#7367F0'
          },
          {
            type: 'bar',
            color: '#EA5455'
          },
          {
            type: 'bar',
            color: '#28C76F'
          }
        ]
      },

      sumOfSafetyCheckStatus: 0,
      numOfSafetyCheckStatus: {
        legend: {
          left: 'center',
          bottom: 'bottom'
        },
        tooltip: {},
        dataset: {
          // Provide data.
          source: [
            ['상태', 'A등급', '점검대상', '점검완료'],
            ['12/22', '4', '9', '11'],
            ['12/23', '2', '7', '9'],
            ['12/24', '5', '5', '7'],
            ['12/25', '7', '2', '9'],
            ['12/26', '5', '4', '12'],
            ['12/27', '6', '5', '9'],
            ['12/28', '4', '7', '6'],
            ['12/29', '3', '11', '2'],
            ['12/30', '4', '12', '6'],
            ['1/1', '2', '2', '8']
          ]
        },
        grid: {
          top: '15%',
          left: '5%',
          right: '5%'
        },
        xAxis: {type: 'category'},
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#BFC9D1',
            formatter (value) {
              return value
            }
          },
          axisLine: {
            show: true
          }
        },
        series: [
          {
            type: 'bar',
            color: '#7367F0'
          },
          {
            type: 'line',
            color: '#EA5455'
          },
          {
            type: 'line',
            color: '#28C76F'
          }
        ]
      },
    }
  },

  created () {

    for (const index in this.numOfEmployees.dataset.source) {
      if (index > 0) {
        const data = this.numOfEmployees.dataset.source[index]
        this.sumOfEmployees += Number(data[1]) + Number(data[2]) + Number(data[3])
      }
    }

    for (const index in this.numOfEquipment.dataset.source) {
      if (index > 0) {
        const data = this.numOfEquipment.dataset.source[index]
        this.sumOfEquipment += Number(data[1]) + Number(data[2]) + Number(data[3])
      }
    }

    this.sumOfSafetyCheckStatus = 11

  },

  methods: {
    clickMenu (index) {
      if (index !== this.selectMenu) {
        this.selectMenu = index
      } else {
        this.selectMenu = 0
      }
    },

    movePage (path, isProject) {
      const projectId = this.$route.params.proj_id
      let rootPath = ''
      if (isProject) rootPath = `/m/project/${projectId}`
      this.$router.push(`${rootPath}${path}`)
    },


  }
}
</script>

<style scoped>
.main-card {
  display: flex;
  align-items: center;
  justify-content: center;

  height:15vh; min-height:80px;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  box-sizing: border-box;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.main-card .main-card-icon {
  display: grid;
  align-items: center;
  justify-content: center;
}
.main-card .main-card-icon img { margin:8px auto;}
.main-card.active {
  background-color: #6670CB;
  color:#fff;
}

.sub-menu {
  margin-bottom:1.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap:16px;
}
.sub-menu .vs-button {
  height:48px;
}
</style>
